module.exports = __webpack_public_path__ + "media/images/favicons/tableaufoundation-9f9cd6112871bdfb421b74f9bc74cbbedb0226b5860673b2a7358455672ea338.ico";